import SlideTemplate from "./SlideTemplate";
import * as appActions from "../actions/app";
import {connect} from "redux-vue";

const ResourcesSlide = {
  props: ['goBack'],
  data() {
    return {
      imgLoad: false,
    };
  },
  methods: {
    onLoadImg () {
      this.imgLoad = true;
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <SlideTemplate key={this.imgLoad.toString()}>
        <div class="p-6 lg:p-10 lg:py-6">

          <div class="flex justify-end mb-3">
            <button type="button" onClick={this.goBack} class="rounded-full bg-brand-green-400 p-5 py-1 text-white uppercase text-sm font-bold focus:outline-none">
              Close
            </button>
          </div>

          <div class="lg:px-20">
            <p class="text-brand-blue-600 text-3xl lg:text-5xl font-bold mb-10 leading-none">
              Resource Documents
            </p>

            <p class="text-xl lg:text-3xl font-bold mb-3">
              Access and Utilization
            </p>

            <p class="text-lg lg:text-2xl leading-snug">
              Facilities can be categorized based their DTP1 rates and drop out rates, to determine if they are
              experiencing challenges with access and utilization. This categorization can be a useful starting point
              for helping facilities use their own data for problem solving and decision making.
            </p>

            <img src="/img/changemanagement/flow-utilization.svg" alt="" class="mt-8 lg:mt-12 mb-12 lg:mb-24" onLoad={this.onLoadImg}/>

            <p class="text-xl lg:text-3xl font-bold mb-3">
              Problem-Solving Tools
            </p>

            <p class="text-lg lg:text-2xl leading-snug">
              While this scenario is fictional, the tools and techniques used to enable problem-solving and data-driven
              micro planning at facilities are similar to those used in real world situations.
              <br/><br/>
              If you are interested in implementing similar initiatives, UI-FHS has created a variety of tools and
              guides to assist health workers with problem-solving and planning, including:
            </p>

            <ul class="flex flex-wrap mb-10 lg:mb-20 leading-none font-bold lg:text-xl text-center">
              <li class="w-1/2 lg:w-1/3 mt-10 lg:mt-20">
                <a target="_blank" href="http://mpffs6apl64314hd71fbb11y-wpengine.netdna-ssl.com/wp-content/uploads/2019/08/QIquickreference_Final.pdf" class="flex flex-col items-center hover:underline">
                  <img src="/img/changemanagement/icn-resource-primary.svg" alt="" class="w-12 lg:w-20 mb-3 lg:mb-6"/>
                  <span class="lg:w-4/6">Implementing Quality Improvement Tools</span>
                </a>
              </li>
              <li class="w-1/2 lg:w-1/3 mt-10 lg:mt-20">
                <a target="_blank" href="http://mpffs6apl64314hd71fbb11y-wpengine.netdna-ssl.com/wp-content/uploads/2018/08/Fishbone-Job-Aid_A1.pdf" class="flex flex-col items-center hover:underline">
                  <img src="/img/changemanagement/icn-resource-primary.svg" alt="" class="w-12 lg:w-20 mb-3 lg:mb-6"/>
                  <span class="lg:w-4/6">Fishbone Diagram Job Aid</span>
                </a>
              </li>
              <li class="w-1/2 lg:w-1/3 mt-10 lg:mt-20">
                <a target="_blank" href="http://mpffs6apl64314hd71fbb11y-wpengine.netdna-ssl.com/wp-content/uploads/2016/04/PDSA-Compilation-Format-for-Woreda-and-PHCU-Levels.docx" class="flex flex-col items-center hover:underline">
                  <img src="/img/changemanagement/icn-resource-primary.svg" alt="" class="w-12 lg:w-20 mb-3 lg:mb-6"/>
                  <span class="lg:w-4/6">PDSA Cycles Template</span>
                </a>
              </li>
              <li class="w-1/2 lg:w-1/3 mt-10 lg:mt-20">
                <a target="_blank" href="http://mpffs6apl64314hd71fbb11y-wpengine.netdna-ssl.com/wp-content/uploads/2018/02/FINALMP_2017.xls" class="flex flex-col items-center hover:underline">
                  <img src="/img/changemanagement/icn-resource-primary.svg" alt="" class="w-12 lg:w-20 mb-3 lg:mb-6"/>
                  <span class="lg:w-4/6">Microplanning Template</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </SlideTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {};
}

function mapActionToProps(dispatch) {
  return {
    goBack: () => dispatch(appActions.goBack()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ResourcesSlide);
